import React from 'react';
import LightVsDark from '../components/KozelBattle/LightVsDark';
import Banner from '../components/KozelBattle/Banner';
import RealTimeScore from '../components/KozelBattle/RealTimeScore';
import Prefer from '../components/KozelBattle/Prefer';
import Battle from '../components/KozelBattle/Battle';
import BannerDown from '../components/KozelBattle/BannerDown';

const KozelBattle = () => {
  return (
    <div>
      <Banner />
      <LightVsDark />
      <RealTimeScore />
      <Prefer />
      <Battle />
      <BannerDown />
    </div>
  );
};

export default KozelBattle;